import {CompetitionEvent} from './CompetitionEvent';

export class CompetitionImageUpdated extends CompetitionEvent {}
